export default __webpack_public_path__ + "static/icon-economic-growth-4ff3274e047366543cd845c159f007c1.svg";